/* eslint-disable i18next/no-literal-string */
import { Alert } from '@hotjar/hotsauce';
import { useHelpHotjarUrl, useTranslation } from '@hotjar/translations';

export const MultipleWidgetHelp = (): JSX.Element => {
  const { t } = useTranslation('feedback');
  const helpHotjarUrl = useHelpHotjarUrl();

  return (
    <Alert
      kind="info"
      actionText={t('wizard.section.targeting.multiple-widgets-info.learn-more')}
      actionHref={`${helpHotjarUrl}/articles/115011761328-Troubleshooting-FAQs-for-Feedback-Widgets#what-if-i-have-multiple-widgets-set-to-target-the-same-page`}
      actionProps={{
        isExternal: true,
      }}
    >
      <span>{t('wizard.section.targeting.multiple-widgets-info.caption')}</span>
      <ul>
        <li>{t('wizard.section.targeting.multiple-widgets-info.surveys-priority')}</li>
        <li>{t('wizard.section.targeting.multiple-widgets-info.creation-date-priority')}</li>
      </ul>
    </Alert>
  );
};
